(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  let searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('page'))
  {
    let pageParam = searchParams.get('page');
    //console.log(pageParam);
    if (pageParam !== "1")
    {
      document.getElementById("t4s-desc-collection").textContent = "";
    }
  }

  } catch(e) { console.error(e); }
})();
})();
